'use client'

import { ReactNode } from 'react'
import { RiveAnim } from '~/components/RiveAnimation'
import { useTranslation } from '~/i18n/useTranslation'

type AppErrorProps = {
    children?: ReactNode
}

export const AppError = ({ children }: AppErrorProps) => {
    const { t } = useTranslation()
    return (
        <div
            className='flex flex-col w-full gap-4 items-center justify-center text-center'
        >
            <RiveAnim
                src={'/void-cat.riv'}
                className='w-96 h-96'
            />
            <h1 className="font-semibold text-3xl">
                {t('error.somethingWentWrong')}
            </h1>
            <h2 className='text-xl text-gray-500'>
                {t('error.tryAgainOrRefresh')}
            </h2>
            {children}
        </div>
    )
}